import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { baseUrl, customHeaders } from '../../../../Containers/Config/index.js';

import { GET_SUB_REGION, GET_SUB_REGION_SUCCESS, GET_SUB_REGION_ERROR } from './../../actionType.js';
import apiCall from '../../apiCall';
import { Constant } from '../../../../Containers/Helpers/constant.js';

function* getSubRegion({ payload }) {
  try {
    const response = yield call(apiCall, {
      url: `${baseUrl}/admin/subRegions`,
      method: 'GET',
      headers: {
        Authorization: Constant?.CLIENT_TOKEN,
        ...customHeaders,
      },
      params: {
        ...payload.urlParam,
        pageIndex: 0,
        pageSize: 8000,
      },
    });

    if (response.status === 200) {
      yield put({
        type: GET_SUB_REGION_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: GET_SUB_REGION_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: GET_SUB_REGION_ERROR, payload: error });
  }
}

export function* watchGetSubRegion() {
  yield takeEvery(GET_SUB_REGION, getSubRegion);
}

function* getSubRegionSaga() {
  yield all([fork(watchGetSubRegion)]);
}

export default getSubRegionSaga;
